// URLSearchParams
import "url-search-params-polyfill";


// "pseudo mutation observer" fix for nodeValue
import "../compatibility/patchNodeValue.js";
